<template>
    <div class="breadcrumb-item" :style="style">
        <FontAwesomeIcon
            v-if="iconBefore"
            :icon="faChevronLeft"
            class="breadcrumb-item__icon breadcrumb-item__icon--before"
        />

        <component
            :is="url ? 'Link' : 'span'"
            :href="url"
            :title="decodeHtmlEntities(label)"
            class="breadcrumb-item__label u-tiny-text"
            :class="{
                'breadcrumb-item__label--truncated': truncationWidth,
                'u-bold': url
            }"
        >
            {{ decodeHtmlEntities(label) }}
        </component>

        <FontAwesomeIcon
            v-if="iconAfter"
            :icon="faChevronRight"
            class="breadcrumb-item__icon breadcrumb-item__icon--after"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import decodeHtmlEntities from '@utils/decode-html-entities';

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    url: {
        type: String,
        required: false,
        default: null,
    },
    iconBefore: {
        type: Boolean,
        required: false,
        default: false,
    },
    iconAfter: {
        type: Boolean,
        required: false,
        default: false,
    },
    truncationWidth: {
        type: Number,
        required: false,
        default: null,
    },
    styling: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const style = computed(() => ({
    '--text-color': props.styling.textColor || 'initial',
    '--icon-color': props.styling.iconColor || 'initial',
    '--link-color': props.styling.linkColor || 'initial',
    '--link-hover-color': props.styling.linkHoverColor || 'initial',
    '--link-active-color': props.styling.linkActiveColor || 'initial',
    '--truncation-width': props.truncationWidth ? `${props.truncationWidth}ch` : 'initial',
}));
</script>

<style lang="scss">
@use 'watson-atom-breadcrumb-item';
</style>
